import React, { useEffect, useRef } from "react";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import { eventuallyInsertReevooScript } from "../utility/reevoo";
import { insertBazaarVoiceScript } from "../utility/bazaar-voice";
import { normalizeRelativePath } from "../utility/paths";

const ReevooBadge = ({ productId, productUrl, isSliderProduct }) => {
  const containerRef = useRef();

  const {
    config: { reevoo },
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        reevoo: isReevooActiveFieldSet {
          isReevooActive
          isBazaarVoiceActive
        }
      }
    }
  `);

  useEffect(() => {
    const container = containerRef.current;
    if (container && productId && !!reevoo?.isReevooActive?.length) {
      eventuallyInsertReevooScript();
    }

    if (
      container &&
      productId &&
      !reevoo?.isReevooActive?.length &&
      !!reevoo?.isBazaarVoiceActive?.length
    ) {
      insertBazaarVoiceScript();
    }
  }, [productId, reevoo]);

  return (
    <div ref={containerRef}>
      {!!reevoo?.isReevooActive?.length && (
        <div className="feefo-product-stars-widget" data-product-sku={productId}></div>
      )}
      {!!reevoo?.isBazaarVoiceActive?.length && !reevoo?.isReevooActive?.length && (
        <div
          data-bv-show="inline_rating"
          data-bv-seo={isSliderProduct && false}
          data-bv-product-id={productId}
          data-bv-redirect-url={`${withPrefix(normalizeRelativePath(productUrl)) + "#reviews"}`}
        ></div>
      )}
    </div>
  );
};

export default React.memo(ReevooBadge);
